<template>
  <span :title="date">{{ date.split(" ")[0] }}</span>
</template>
<script>
  export default {
    props: ["date"],
  };
</script>
